import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {CardsAndPromotions} from '../cards-and-promotions.js';

import {classicCardsFactory} from './classic-cards.factory.js';

import SCHEMA from './classic-cards.schema.yaml';
import PALETTE_SCHEMA from './classic-cards.palette-schema.yaml';

class ClassicCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'ClassicCards';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mergeTo(classicCardsFactory(PALETTE), {
            InplayFallbackEventCard: {
                title: '$EVENT_CARDS.FALLBACK.INPLAY.TITLE',
                content: '$EVENT_CARDS.FALLBACK.INPLAY.CONTENT',
            },
            EventCardsCarousel: {
                fallbackSportId: GENBET_BASED ? 'soccer' : 'tennis',
            },
        });
    }
}

export const ClassicCards = new ClassicCardsFeature(CardsAndPromotions);
